import React, { useEffect, useState } from "react";
import DatePicker from "../DatePicker";
import {
  formatCurrency,
  getAlert,
  getData,
  getDataWithComp,
  parseCurrency,
  useEscapeClose,
  uploadMultipleSlips, // เพิ่มการ import
} from "../../../utils/SamuiUtils";
import moment from "moment";

const PAYMENT_METHODS = {
  cash: "เงินสด",
  transfer: "โอนเงิน",
  cheque: "เช็ค",
  fee: "ค่าธรรมเนียม",
  other: "อื่นๆ ระบุ..",
  credit: "เครดิต",
  unpaid: "ค้างชำระ",
};

const PaymentModal = ({
  mode,
  show,
  grandTotal,
  paymentType,
  setPaymentType,
  paymentAmount,
  setPaymentAmount,
  payDatetime,
  setPayDatetime,
  handlePayTypeClose,
  handleUpdatePayment,
  handleUploadSlip,
  base64Image,
  setBase64Image,
  chequeNo,
  setChequeNo,
  chequeName,
  setChequeName,
  chequeBranch,
  setChequeBranch,
  chequeDate,
  setChequeDate,
  bankMasterId,
  setBankMasterId,
  bankInputMode,
  setBankInputMode,
  payToAccNo,
  setPayToAccNo,
  payToAccName,
  setPayToAccName,
  bankId,
  setBankId,
  showConfirmModal,
  setShowConfirmModal,
  checkPayment,
  isAllowCredit,
  // เพิ่ม props สำหรับ multiple slip upload
  docId,
  docCodeId,
  multipleSlipImages,
  setMultipleSlipImages,
  handleMultipleSlipUpload,
  handleRemoveSlipImage,
  handleClearAllSlips,
  isUploadingSlips,
  otherRemark,
  setOtherRemark,
}) => {
  const [isCalendarOpen, setIsCalendarOpen] = useState(false);
  const [masterBankDataList, setMasterBankDataList] = useState([]);
  const [bankDataList, setBankDataList] = useState([]);

  useEscapeClose(show, handlePayTypeClose);

  useEffect(() => {
    const loadMasterData = async () => {
      const masterBankData = await getData(
        "Tb_Set_Bank_Master",
        "1 = 1 ORDER BY Bank_Master_Id ASC"
      );
      if (masterBankData && masterBankData.length > 0) {
        setMasterBankDataList(masterBankData);
      }
      const bankCondition =
        window.location.pathname === "/deposit-document"
          ? "AND Bank_Status = 'Y' AND APAR_Type = 'AR' ORDER BY Bank_Id ASC"
          : "AND Bank_Status = 'Y' AND APAR_Type = 'CP' ORDER BY Bank_Id ASC";
      const bankDataList = await getDataWithComp("Tb_Set_Bank", bankCondition);
      if (bankDataList && bankDataList.length > 0) {
        setBankDataList(bankDataList);
      }
      setChequeBranch("ธนาคารกสิกรไทย");
    };
    loadMasterData();
  }, []);

  const totalPaid = Object.values(paymentAmount).reduce(
    (acc, val) => acc + parseCurrency(val || 0),
    0
  );

  useEffect(() => {
    if (mode === "I" && show) {
      // เคลียค่าทั้งหมด
      setPaymentType({
        cash: false,
        transfer: false,
          cheque: false,
          fee: false,
          other: false,
        credit: false,
        unpaid: false,
      });
      setPaymentAmount({
        cash: "0.00",
        transfer: "0.00",
          cheque: "0.00",
          fee: "0.00",
          other: "0.00",
        credit: "0.00",
        unpaid: "0.00",
      });
      setOtherRemark && setOtherRemark("");
      setChequeNo("");
      setChequeName("");
      setChequeBranch("");
      setChequeDate("");
      setBase64Image("");
      // เคลียร์ไฟล์หลายไฟล์
      setMultipleSlipImages([]);
    }

    if (mode === "U" && paymentType.unpaid) {
      togglePaymentMethod("unpaid");
      togglePaymentMethod("unpaid");
    }
  }, [mode, show]);

  const togglePaymentMethod = (method) => {
    setPaymentType((prev) => {
      const newSelected = { ...prev, [method]: !prev[method] };

      // หาวิธีการชำระเงินที่ถูกเลือกทั้งหมด
      const selectedMethods = Object.keys(newSelected).filter(
        (key) => newSelected[key]
      );

      if (newSelected[method]) {
        // ถ้านี่เป็นวิธีแรกที่ถูกเลือก กำหนดยอดชำระให้มัน
        if (selectedMethods.length === 1) {
          setPaymentAmount((prevPayments) => ({
            ...prevPayments,
            [method]: formatCurrency(grandTotal),
          }));
        }
      } else {
        // ถ้าเอาวิธีนี้ออก ให้เคลียร์ค่าเป็น 0.00
        setPaymentAmount((prevPayments) => ({
          ...prevPayments,
          [method]: "0.00",
        }));

        // ถ้ามีวิธีอื่นที่เหลือ และวิธีที่ถูกถอดออกเป็นตัวแรก ให้กำหนด grandTotal ให้ตัวใหม่
        if (selectedMethods.length > 1) {
          const firstMethod = selectedMethods.find((key) => key !== method);
          if (firstMethod) {
            setPaymentAmount((prevPayments) => ({
              ...prevPayments,
              [firstMethod]: formatCurrency(grandTotal),
            }));
          }
        }
      }

      // ถ้าถอดเช็คออก ให้ล้างข้อมูลเช็ค
      if (method === "cheque" && !newSelected[method]) {
        setChequeNo("");
        setChequeName("");
        setChequeBranch("");
        setChequeDate("");
      }

      // ถ้าถอดโอนเงินออก ให้ล้างไฟล์สลิป
      if (method === "transfer" && !newSelected[method]) {
        setBase64Image("");
        if (setMultipleSlipImages) {
          setMultipleSlipImages([]);
        }
      }

      if (method === "other" && !newSelected[method] && setOtherRemark) {
        setOtherRemark("");
      }

      return newSelected;
    });

    // เรียก handleBlur เพื่อจัดการค่าใหม่
    handleBlur(method, formatCurrency("0"));
  };

  const handleChange = (method, value) => {
    setPaymentAmount((prev) => ({
      ...prev,
      [method]: value,
    }));
  };

  const handleFocus = (field, value) => {
    const rawValue = parseCurrency(value);
    setPaymentAmount((prev) => ({ ...prev, [field]: rawValue }));
  };

  const handleBlur = (field, value) => {
    const formattedValue = formatCurrency(parseCurrency(value));
    setPaymentAmount((prev) => ({ ...prev, [field]: formattedValue }));
  };

  const handleConfirmPayment = async () => {
    try {
      const hasSelectedPaymentMethod = Object.values(paymentType).some(
        (isSelected) => isSelected
      );
      if (!hasSelectedPaymentMethod) {
        getAlert("FAILED", "กรุณาเลือกช่องทางการชำระเงิน");
        setShowConfirmModal(false);
        return;
      }
      if (parseCurrency(totalPaid) === 0) {
        getAlert("FAILED", "กรุณาระบุยอดชำระเงิน");
        setShowConfirmModal(false);
        return;
      }
      setShowConfirmModal(false);

      await handleUpdatePayment();

      // สำหรับ /bill และ /billofsale เท่านั้น (ไม่รวม /quotation)
      if (
        (window.location.pathname === "/bill" ||
          window.location.pathname === "/billofsale" ||
          window.location.pathname === "/quotation") &&
        paymentType.transfer &&
        multipleSlipImages &&
        multipleSlipImages.length > 0 &&
        docId &&
        docCodeId
      ) {
        try {
          const slipFiles = multipleSlipImages.map((image) => image.base64);
          await uploadMultipleSlips(slipFiles, docId, docCodeId);
          getAlert(
            "OK",
            `อัพโหลดสลิป ${multipleSlipImages.length} ไฟล์เรียบร้อยแล้ว`
          );
        } catch (uploadError) {
          console.log("uploadError", uploadError);
        }
      } else if (paymentType.transfer && base64Image && handleUploadSlip) {
        await handleUploadSlip();
      }

      handlePayTypeClose();
    } catch (error) {
      getAlert("FAILED", error.message || "เกิดข้อผิดพลาดในการชำระเงิน");
      setShowConfirmModal(false);
    }
  };

  // เพิ่มการจัดการ file upload แบบเดียว (สำหรับ backward compatibility)
  const handleFileUpload = (event) => {
    const file = event.target.files[0];
    if (file) {
      // ตรวจสอบขนาดไฟล์ (เช่น ไม่เกิน 5MB)
      if (file.size > 5 * 1024 * 1024) {
        getAlert(
          "FAILED",
          "ขนาดไฟล์ใหญ่เกินไป กรุณาเลือกไฟล์ที่มีขนาดไม่เกิน 5MB"
        );
        event.target.value = "";
        return;
      }

      // ตรวจสอบประเภทไฟล์
      const allowedTypes = [
        "image/jpeg",
        "image/jpg",
        "image/png",
        "image/gif",
      ];
      if (!allowedTypes.includes(file.type)) {
        getAlert(
          "FAILED",
          "กรุณาเลือกไฟล์รูปภาพที่ถูกต้อง (JPEG, JPG, PNG, GIF)"
        );
        event.target.value = "";
        return;
      }

      const reader = new FileReader();
      reader.onloadend = () => {
        setBase64Image(reader.result);
      };
      reader.onerror = () => {
        getAlert("FAILED", "เกิดข้อผิดพลาดในการอ่านไฟล์");
        event.target.value = "";
      };
      reader.readAsDataURL(file);
    }
  };

  const GROUP_A = ["cash", "transfer", "cheque", "fee"];
  if (window.location.pathname === "/bill") GROUP_A.push("other");
  const GROUP_B = ["credit"];
  const GROUP_C = ["unpaid"];

  const isGroupASelected = GROUP_A.some((method) => paymentType[method]);
  const isGroupBSelected = GROUP_B.some((method) => paymentType[method]);
  const isGroupCSelected = GROUP_C.some((method) => paymentType[method]);

  if (!show) return null;

  return (
    <div
      className="modal"
      style={{
        display: "block",
        backgroundColor: "rgba(0, 0, 0, 0.5)",
        zIndex: 999999,
      }}
    >
      <div className="modal-dialog modal-md" role="document">
        <div
          className="modal-content shadow-lg"
          style={{
            borderRadius: "15px",
            overflow: "hidden",
            minHeight: isCalendarOpen ? "900px" : "550px",
          }}
        >
          <div
            className="modal-header"
            style={{
              backgroundColor: "#EF6C00",
              borderBottom: "none",
              padding: "20px",
            }}
          >
            <h5 className="modal-title fw-bold text-white">ชำระเงิน</h5>
            <button
              type="button"
              className="btn-close btn-close-white"
              onClick={handlePayTypeClose}
              aria-label="Close"
            ></button>
          </div>
          <div className="modal-body" style={{ padding: "30px 20px" }}>
            <div
              className="p-3 text-center rounded"
              style={{ backgroundColor: "#FFEFCC" }}
            >
              <h4 className="fw-bold mt-2">
                ยอดชำระ: {formatCurrency(grandTotal)} บาท
              </h4>
              {(paymentType.cash ||
                paymentType.transfer) && (
                <div className="mt-3 d-flex flex-column align-items-center">
                  <label className="fw-bold mb-2">วันที่ชำระเงิน</label>
                  <div style={{ width: "200px" }}>
                    <DatePicker
                      label=""
                      name="payDatetime"
                      value={payDatetime}
                      onChange={(date) => {
                        const newValue =
                          date && date instanceof moment
                            ? date.format("YYYY-MM-DD")
                            : date;
                        setPayDatetime(newValue);
                        setTimeout(() => setIsCalendarOpen(false), 100);
                      }}
                      disabled={false}
                    />
                  </div>
                </div>
              )}
              <div className="mt-4 w-100 text-center mx-auto">
                {Object.keys(PAYMENT_METHODS)
                    .filter((method) => {
                      if (method === "fee") return window.location.pathname === "/bill" || window.location.pathname === "/billofsale";
                      if (method === "other") return window.location.pathname === "/bill";

                      const allowedForBill = (window.location.pathname !== "/bill" || ["cash", "transfer", "cheque"].includes(method));
 
                      const hideCreditOnBillOfSaleUpdate = (window.location.pathname === "/billofsale" && mode === "U" && !isAllowCredit && method === "credit");

                      return allowedForBill && !hideCreditOnBillOfSaleUpdate;
                    })
                  .map((method) => {
                    const isDisabled =
                      (GROUP_A.includes(method) &&
                        (isGroupBSelected || isGroupCSelected)) ||
                      (GROUP_B.includes(method) &&
                        (isGroupASelected || isGroupCSelected)) ||
                      (GROUP_C.includes(method) &&
                        (isGroupASelected || isGroupBSelected));

                    const notApproveForInput =
                      (GROUP_B.includes(method) && isGroupBSelected) ||
                      (GROUP_C.includes(method) && isGroupCSelected);

                    return (
                      <div
                        className="d-flex align-items-center justify-content-between my-2"
                        key={method}
                      >
                        <button
                          className="btn"
                          onClick={() => togglePaymentMethod(method)}
                          disabled={isDisabled}
                          style={{
                            width: "130px",
                            flexShrink: 0,
                            borderRadius: "6px",
                            transition: "0.3s",
                            backgroundColor: paymentType[method]
                              ? "#EF6C00"
                              : "white",
                            color: paymentType[method] ? "white" : "black",
                            fontWeight: paymentType[method] ? "bold" : "normal",
                            cursor: isDisabled ? "not-allowed" : "pointer",
                            opacity: isDisabled ? 0.5 : 1,
                          }}
                        >
                          {PAYMENT_METHODS[method]}
                        </button>
                        <div
                          className="ms-3 flex-grow-1 d-flex align-items-center"
                          style={{ minWidth: 0 }}
                        >
                        {method === "other" ? (
                          <input
                            type="text"
                            inputMode="text"
                            className="form-control"
                            placeholder="กรอกรายละเอียด..."
                            value={otherRemark || ""}
                            onChange={(e) => setOtherRemark && setOtherRemark(e.target.value)}
                            disabled={
                              !paymentType[method] ||
                              isDisabled ||
                              notApproveForInput
                            }
                            style={{
                              flex: 1,
                              minWidth: 0,
                              borderRadius: "6px",
                              boxShadow: "inset 0 0 5px rgba(0,0,0,0.1)",
                              backgroundColor: paymentType[method]
                                ? "white"
                                : "#f0f0f0",
                              opacity:
                                !paymentType[method] ||
                                isDisabled ||
                                notApproveForInput
                                  ? 0.5
                                  : 1,
                            }}
                          />
                        ) : (
                          <>
                            <input
                              type="text"
                              className="form-control text-end"
                              value={paymentAmount[method]}
                              onChange={(e) => handleChange(method, e.target.value)}
                              onFocus={(e) => handleFocus(method, e.target.value)}
                              onBlur={(e) => handleBlur(method, e.target.value)}
                              disabled={
                                !paymentType[method] ||
                                isDisabled ||
                                notApproveForInput
                              }
                              style={{
                                flex: 1,
                                minWidth: 0,
                                borderRadius: "6px",
                                boxShadow: "inset 0 0 5px rgba(0,0,0,0.1)",
                                backgroundColor: paymentType[method]
                                  ? "white"
                                  : "#f0f0f0",
                                opacity:
                                  !paymentType[method] ||
                                  isDisabled ||
                                  notApproveForInput
                                    ? 0.5
                                    : 1,
                              }}
                            />
                            <span className="ms-2">บาท</span>
                          </>
                        )}
                        </div>
                      </div>
                    );
                  })}
              </div>
              <h6 className="fw-bold mt-4 text-center">
                ยอดจ่าย:{" "}
                <span
                  style={{ color: totalPaid >= grandTotal ? "green" : "red" }}
                >
                  {formatCurrency(totalPaid)}
                </span>{" "}
                บาท
              </h6>
            </div>

            {/* สำหรับโอน - รองรับหลายไฟล์สำหรับ /bill, /billofsale, /quotation */}
            {paymentType.transfer && (
              <div className="mt-3">
                {window.location.pathname === "/bill" ||
                window.location.pathname === "/billofsale" ||
                window.location.pathname === "/quotation" ? (
                  // UI สำหรับ /bill, /billofsale, /quotation - รองรับหลายไฟล์
                  <>
                    <div className="text-center">
                      <input
                        type="file"
                        id="multipleFileInput"
                        style={{ display: "none" }}
                        onChange={handleMultipleSlipUpload}
                        accept=".png, .jpg, .jpeg, .gif, .svg"
                        multiple
                      />

                      <button
                        className="btn me-2"
                        onClick={() =>
                          document.getElementById("multipleFileInput").click()
                        }
                        style={{
                          borderRadius: "5px",
                          backgroundColor: "#EF6C00",
                          color: "#fff",
                          padding: "8px 16px",
                          fontSize: "14px",
                          boxShadow: "0 4px 10px rgba(0, 0, 0, 0.1)",
                          transition: "background-color 0.3s",
                        }}
                        disabled={
                          multipleSlipImages.length >= 100 || isUploadingSlips
                        }
                        onMouseEnter={(e) =>
                          (e.target.style.backgroundColor = "#d85d00")
                        }
                        onMouseLeave={(e) =>
                          (e.target.style.backgroundColor = "#EF6C00")
                        }
                      >
                        <i className="fa fa-plus me-1"></i>
                        {multipleSlipImages.length > 0
                          ? "เพิ่มสลิป"
                          : "อัพโหลดสลิป"}{" "}
                        {window.location.pathname === "/quotation" &&
                          "(ใบเสนอราคา)"}
                      </button>

                      {multipleSlipImages.length > 0 && (
                        <button
                          className="btn btn-outline-danger"
                          onClick={handleClearAllSlips}
                          disabled={isUploadingSlips}
                          style={{
                            borderRadius: "5px",
                            padding: "8px 16px",
                            fontSize: "14px",
                          }}
                        >
                          <i className="fa fa-trash me-1"></i>
                          ลบทั้งหมด
                        </button>
                      )}
                    </div>

                    <div className="text-muted small text-center mt-2">
                      ไฟล์ที่เลือกแล้ว: {multipleSlipImages.length}
                      {isUploadingSlips && (
                        <span className="text-primary ms-2">
                          <i className="fa fa-spinner fa-spin"></i>{" "}
                          กำลังอัพโหลด...
                        </span>
                      )}
                    </div>

                    {/* แสดงไฟล์ที่เลือก */}
                    {multipleSlipImages.length > 0 && (
                      <div className="row g-2 mt-3">
                        {multipleSlipImages.map((image, index) => (
                          <div key={image.id} className="col-4">
                            <div
                              className="card"
                              style={{
                                border: "1px solid #ddd",
                                borderRadius: "8px",
                                overflow: "hidden",
                              }}
                            >
                              <div className="card-header bg-light d-flex justify-content-between align-items-center py-1">
                                <span className="small fw-bold">
                                  ไฟล์ {index + 1}
                                </span>
                                <button
                                  className="btn btn-sm btn-danger"
                                  onClick={() =>
                                    handleRemoveSlipImage(image.id)
                                  }
                                  disabled={isUploadingSlips}
                                  style={{
                                    borderRadius: "50%",
                                    width: "25px",
                                    height: "25px",
                                    padding: "0",
                                    fontSize: "12px",
                                  }}
                                >
                                  <i className="fa fa-times"></i>
                                </button>
                              </div>
                              <div className="card-body p-2">
                                {image.type.startsWith("image/") ? (
                                  <img
                                    src={image.base64}
                                    alt={`สลิปที่ ${index + 1}`}
                                    style={{
                                      width: "100%",
                                      maxHeight: "120px",
                                      objectFit: "contain",
                                      borderRadius: "5px",
                                    }}
                                  />
                                ) : (
                                  <div className="text-center p-2">
                                    <i className="fa fa-file-pdf fa-2x text-danger mb-1"></i>
                                    <div className="small text-muted text-truncate">
                                      {image.name}
                                    </div>
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>
                    )}

                    {/* สำหรับ backward compatibility - แสดงไฟล์เดียวถ้ามี base64Image */}
                    {base64Image && multipleSlipImages.length === 0 && (
                      <div className="mt-3 text-center">
                        <p
                          style={{
                            fontSize: "14px",
                            fontWeight: "500",
                            color: "#333",
                          }}
                        >
                          รูปภาพสลิป:
                        </p>
                        <img
                          src={base64Image}
                          alt="อัพโหลดสลิป"
                          style={{
                            maxWidth: "200px",
                            border: "1px solid #ddd",
                            borderRadius: "5px",
                            boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
                          }}
                        />
                        <div className="mt-2">
                          <button
                            className="btn btn-outline-danger btn-sm"
                            onClick={() => setBase64Image("")}
                            style={{ fontSize: "12px" }}
                          >
                            ลบรูป
                          </button>
                        </div>
                      </div>
                    )}
                  </>
                ) : (
                  // UI เดิมสำหรับ page อื่นๆ (ไฟล์เดียว)
                  <div className="text-center">
                    <input
                      type="file"
                      id="fileInput"
                      style={{ display: "none" }}
                      onChange={handleFileUpload}
                      accept=".png, .jpg, .jpeg, .gif, .svg"
                    />
                    <button
                      className="btn"
                      onClick={() =>
                        document.getElementById("fileInput").click()
                      }
                      style={{
                        borderRadius: "5px",
                        backgroundColor: "#EF6C00",
                        color: "#fff",
                        padding: "8px 16px",
                        fontSize: "14px",
                        boxShadow: "0 4px 10px rgba(0, 0, 0, 0.1)",
                        transition: "background-color 0.3s",
                      }}
                      onMouseEnter={(e) =>
                        (e.target.style.backgroundColor = "#d85d00")
                      }
                      onMouseLeave={(e) =>
                        (e.target.style.backgroundColor = "#EF6C00")
                      }
                    >
                      อัพโหลดสลิป
                    </button>
                    {base64Image && (
                      <div className="mt-3">
                        <p
                          style={{
                            fontSize: "14px",
                            fontWeight: "500",
                            color: "#333",
                          }}
                        >
                          รูปภาพสลิป:
                        </p>
                        <img
                          src={base64Image}
                          alt="อัพโหลดสลิป"
                          style={{
                            maxWidth: "20%",
                            border: "1px solid #ddd",
                            borderRadius: "5px",
                            boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
                          }}
                        />
                      </div>
                    )}
                  </div>
                )}
              </div>
            )}

            {/* สำหรับเช็ค */}
            {paymentType.cheque && (
              <div
                className="p-3 rounded mt-4"
                style={{ backgroundColor: "#DCDCDC" }}
              >
                <h6 className="fw-bold mb-3">รายละเอียดเช็ค</h6>
                <div className="row g-3">
                  <div className="col-12">
                    <label className="form-label fw-bold">เลขที่เช็ค</label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="กรอกเลขที่เช็ค"
                      value={chequeNo}
                      onChange={(e) => setChequeNo(e.target.value)}
                    />
                  </div>
                  <div className="col-12">
                    <label className="form-label fw-bold">ชื่อเช็ค</label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="ชื่อเช็ค"
                      value={chequeName}
                      onChange={(e) => setChequeName(e.target.value)}
                    />
                  </div>
                  <div className="col-12">
                    <label className="form-label fw-bold">เลือกธนาคาร</label>
                    <select
                      className="form-select mb-2"
                      value={bankMasterId}
                      onChange={(e) => {
                        const selectedBank = masterBankDataList.find(
                          (bank) =>
                            parseCurrency(bank.Bank_Master_Id) ===
                            parseCurrency(e.target.value)
                        );
                        if (selectedBank) {
                          setBankMasterId(e.target.value);
                          setChequeBranch(selectedBank.B_Name_TH);
                        } else {
                          setBankMasterId(e.target.value);
                          setChequeBranch("");
                        }
                      }}
                    >
                      <option value="">-- เลือกธนาคาร --</option>
                      {masterBankDataList.map((bank) => (
                        <option
                          key={bank.Bank_Master_Id}
                          value={bank.Bank_Master_Id}
                        >
                          {bank.B_Name_TH}
                        </option>
                      ))}
                    </select>
                  </div>
                  <style>
                    {`
                      .modal .rdtPicker {
                        margin-top: -250px;
                      }
                    `}
                  </style>
                  <div className="col-12">
                    <label className="form-label fw-bold">ลงวันที่</label>
                    <DatePicker
                      label=""
                      name="chequeDate"
                      value={chequeDate}
                      onChange={(date) => {
                        const newValue =
                          date && date instanceof moment
                            ? date.format("YYYY-MM-DD")
                            : date;
                        setChequeDate(newValue);
                        setTimeout(() => setIsCalendarOpen(false), 100);
                      }}
                      disabled={false}
                    />
                  </div>
                </div>
              </div>
            )}

            {paymentType.transfer && (
              <div
                className="p-3 rounded mt-4"
                style={{ backgroundColor: "#DCDCDC" }}
              >
                <h6 className="fw-bold mb-3">รายละเอียดธนาคาร</h6>

                <div className="mb-3">
                  <div className="form-check form-check-inline">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="bankInputMode"
                      id="selectBank"
                      value="select"
                      checked={bankInputMode === "select"}
                      onChange={() => setBankInputMode("select")}
                    />
                    <label className="form-check-label" htmlFor="selectBank">
                      เลือกธนาคารจากข้อมูลตั้งต้น
                    </label>
                  </div>
                  <div className="form-check form-check-inline">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="bankInputMode"
                      id="manualBank"
                      value="manual"
                      checked={bankInputMode === "manual"}
                      onChange={() => setBankInputMode("manual")}
                    />
                    <label className="form-check-label" htmlFor="manualBank">
                      ระบุเอง
                    </label>
                  </div>
                </div>

                {bankInputMode === "select" && (
                  <select
                    className="form-select"
                    value={bankId}
                    onChange={(e) => setBankId(e.target.value)}
                  >
                    <option value="">-- เลือกบัญชีธนาคาร --</option>
                    {bankDataList.map((acc) => (
                      <option key={acc.Bank_Id} value={acc.Bank_Id}>
                        {acc.Bank_Account} - {acc.Bank_Name_TH}
                      </option>
                    ))}
                  </select>
                )}

                {bankInputMode === "manual" && (
                  <>
                    <select
                      className="form-select mb-2"
                      value={bankMasterId}
                      onChange={(e) => setBankMasterId(e.target.value)}
                    >
                      <option value="">-- เลือกธนาคาร --</option>
                      {masterBankDataList.map((bank) => (
                        <option
                          key={bank.Bank_Master_Id}
                          value={bank.Bank_Master_Id}
                        >
                          {bank.B_Name_TH}
                        </option>
                      ))}
                    </select>
                    <input
                      type="text"
                      className="form-control mb-2"
                      placeholder="เลขที่บัญชี"
                      value={payToAccNo}
                      onChange={(e) => setPayToAccNo(e.target.value)}
                    />
                    <input
                      type="text"
                      className="form-control"
                      placeholder="ชื่อบัญชี"
                      value={payToAccName}
                      onChange={(e) => setPayToAccName(e.target.value)}
                    />
                  </>
                )}
              </div>
            )}
          </div>
          <div className="modal-footer" style={{ borderTop: "none" }}>
            <button
              type="button"
              className="btn btn-outline-secondary me-2"
              onClick={handlePayTypeClose}
              style={{ borderRadius: "5px" }}
              disabled={isUploadingSlips}
            >
              ยกเลิก
            </button>
            <button
              type="button"
              className="btn"
              onClick={() => checkPayment()}
              disabled={isUploadingSlips}
              style={{
                borderRadius: "5px",
                backgroundColor: "#EF6C00",
                color: "#fff",
                opacity: isUploadingSlips ? 0.7 : 1,
              }}
            >
              {isUploadingSlips ? (
                <>
                  <i className="fa fa-spinner fa-spin me-2"></i>
                  กำลังประมวลผล...
                </>
              ) : (
                "บันทึกรายการชำระเงิน"
              )}
            </button>
          </div>

          {showConfirmModal && (
            <div
              className="modal fade show"
              tabIndex="-1"
              style={{
                display: "block",
                backgroundColor: "rgba(0, 0, 0, 0.5)",
              }}
            >
              <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content">
                  <div
                    className="modal-header"
                    style={{ backgroundColor: "#FFE0B2", color: "#EF6C00" }}
                  >
                    <h5 className="modal-title fw-bold">ยืนยันการชำระเงิน</h5>
                    <button
                      type="button"
                      className="btn-close"
                      onClick={() => setShowConfirmModal(false)}
                      aria-label="Close"
                    ></button>
                  </div>
                  <div className="modal-body">
                    <p className="text-center">
                      คุณแน่ใจว่าต้องการบันทึกรายการชำระเงินหรือไม่?
                    </p>
                    {(window.location.pathname === "/bill" ||
                      window.location.pathname === "/billofsale") &&
                      paymentType.transfer &&
                      multipleSlipImages.length > 0 && (
                        <p className="text-center text-muted">
                          <small>
                            จะมีการอัพโหลดสลิป {multipleSlipImages.length} ไฟล์
                          </small>
                        </p>
                      )}
                  </div>
                  <div className="modal-footer justify-content-center">
                    <button
                      type="button"
                      className="btn"
                      onClick={handleConfirmPayment}
                      disabled={isUploadingSlips}
                      style={{
                        width: "120px",
                        backgroundColor: "#EF6C00",
                        color: "#fff",
                        opacity: isUploadingSlips ? 0.7 : 1,
                      }}
                    >
                      {isUploadingSlips ? (
                        <i className="fa fa-spinner fa-spin"></i>
                      ) : (
                        "ยืนยัน"
                      )}
                    </button>
                    <button
                      type="button"
                      className="btn btn-danger mx-2"
                      onClick={() => setShowConfirmModal(false)}
                      disabled={isUploadingSlips}
                      style={{ width: "120px" }}
                    >
                      ยกเลิก
                    </button>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default PaymentModal;
